import { __ } from '@wordpress/i18n';

/**
 * Get status
 * @param {boolean} confirmed
 * @param {boolean} joinable
 * @returns {JSX.Element}
 */
const CourseListItemStartEnd = ({ start, end }) => {
	const formatter = new Intl.DateTimeFormat('fi', {
		day: 'numeric',
		month: 'numeric',
		year: 'numeric',
	});
	const startDate = new Date(start);
	const endDate = new Date(end);

	return (
		<div className="upcoming-event-list__item__start-end-date">
			{formatter.format(startDate)} - {formatter.format(endDate)}
		</div>
	);
};

export default CourseListItemStartEnd;
